export default (array, size, num) => {
  --num // because pages logically start with 1, but technically with 0
  return array.slice(num * size, (num + 1) * size)
}
